import readOnly from './read-only';

export default {
  readOnly,
};
